/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function StarSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clipPath="url(#clip0_1331_43868)">
                <path d="M15.9385 6.50619C15.8687 6.27849 15.7387 6.07596 15.5636 5.92184C15.3884 5.76773 15.1751 5.66828 14.9482 5.63491L10.9074 5.02235L9.10022 1.2026C8.99895 0.988209 8.84216 0.807674 8.64762 0.681431C8.45308 0.555189 8.22854 0.488281 7.99943 0.488281C7.77032 0.488281 7.54579 0.555189 7.35124 0.681431C7.1567 0.807674 6.99992 0.988209 6.89865 1.2026L5.09147 5.02235L1.05072 5.63491C0.824147 5.66939 0.611332 5.76927 0.436302 5.92326C0.261272 6.07725 0.130998 6.27923 0.0601918 6.50638C-0.0106144 6.73353 -0.0191329 6.97681 0.0355982 7.20875C0.0903293 7.44068 0.20613 7.65203 0.369924 7.81894L3.29469 10.7925L2.6043 14.9903C2.56494 15.2259 2.58972 15.4683 2.67582 15.6899C2.76193 15.9116 2.9059 16.1036 3.09139 16.2442C3.27688 16.3847 3.49644 16.4682 3.72512 16.4851C3.95381 16.502 4.18245 16.4516 4.38508 16.3397L7.99943 14.3577L11.6138 16.3397C11.8165 16.4506 12.0449 16.5002 12.2732 16.4828C12.5014 16.4655 12.7205 16.3819 12.9057 16.2416C13.0909 16.1013 13.2348 15.9098 13.3212 15.6886C13.4075 15.4675 13.433 15.2256 13.3946 14.9903L12.7042 10.7925L15.6289 7.8181C15.7936 7.65191 15.9099 7.44066 15.9647 7.20861C16.0194 6.97656 16.0104 6.73311 15.9385 6.50619Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_1331_43868">
                    <rect width="16" height="16" fill="white" transform="translate(0 0.488281)" />
                </clipPath>
            </defs>
        </svg>
    );
}
